export const DEFAULT_DATE_TIME = 'DD.MM.YYYY, HH:mm';
export const DEFAULT_TIME = 'HH:mm';
export const DEFAULT_DATE = 'DD-MM-YYYY';
export const DATE_WITH_DOTS = 'DD.MM.YYYY';
